import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromAddress from '../address/address.reducer'
import { AddressRoutingModule } from './address-routing.module'
import { AddressEffects } from './address.effects'
import { AddressSerializer } from './address.serializer'
import { AddressService } from './address.service'
import { AddressTableComponent } from './address-table/table.component'
import { AddressCreateModalComponent } from './create-modal/show.component'
import { AddressFormComponent } from './form/form.component'
import { AddressUpdateModalComponent } from './update-modal/show.component'

@NgModule({
    imports: [
        AddressRoutingModule,
        SharedModule,
        StoreModule.forFeature(fromAddress.FEATURE_NAME, fromAddress.addressReducer),
        EffectsModule.forFeature([AddressEffects])
    ],
    declarations: [
        AddressTableComponent,
        AddressCreateModalComponent,
        AddressUpdateModalComponent,
        AddressFormComponent
    ],
    exports: [
        AddressTableComponent,
        AddressCreateModalComponent,
        AddressUpdateModalComponent,
        AddressFormComponent
    ],
    providers: [
        AddressService,
        {
            provide: AddressSerializer,
            useClass: AddressSerializer
        }
    ]
})
export class AddressModule {}
